
import React, { useEffect, useState } from "react";
import { TextField, Select, MenuItem, Button, Box, Grid, InputLabel, FormControl, FormHelperText, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { newairlineproduct, updateairlineproduct } from "../../../store/Admin/Airlineproduct/Airlineproductslice";
import { updatenotificationdata } from "../../../store/Admin/Common/CommonSlice";
import { airlines_list } from '../../../store/Admin/Common/CommonSlice';
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const productOptions = ["Priority", "General", "Express"];

const AirlineproductForm = ({ setTab, props, tab }) => {
  const [selectedCarr, setSelectedCarr] = useState("");
  const [numCarrCode, setNumCarrCode] = useState("");
  const [carrName, setCarrName] = useState("");
  const [selectedCarr1, setSelectedCarr1] = useState(props?.airline_product_id?.carr_code);
  const [numCarrCode1, setNumCarrCode1] = useState(props?.airline_product_id?.num_carr_code);
  const [carrName1, setCarrName1] = useState(props?.airline_product_id?.carr_name);
  const [productType, setProductType] = useState("");
  const [remarks, setRemarks] = useState("");
  const [productList, setProductList] = useState([]);
  const [carrOptions, setCarrOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [editMode, setEditMode] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(airlines_list()).then((res) => {
      if (res?.payload?.status === 200) {
        setCarrOptions(res?.payload?.data?.data);
      }
    }).catch((err) => {
      console.log("error", err);
    });
  }, [dispatch]);

  useEffect(() => {
    if (props?.product_type) {
      setProductList(
        props?.product_type?.map((item) => ({
          producttype: item.product_type,
          remarks: item.remarks,
        }))
      );
    }
  }, [props]);

  const validate = () => {
    let tempErrors = {};
    if (tab === 1) {
      if (!selectedCarr) tempErrors.selectedCarr = "Carrier Code is required";
      if (productList?.length === 0) {
        if (!productType) tempErrors.productType = "Product Type is required";
        if (!remarks) tempErrors.remarks = "Remarks cannot be empty";
      }
    } else if (tab === 2) {
      if (!selectedCarr1) tempErrors.selectedCarr1 = "Carrier Code is required";
      if (productList?.length === 0) {
        if (!productType) tempErrors.productType = "Product Type is required";
        if (!remarks) tempErrors.remarks = "Remarks cannot be empty";
      }
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleCarrChange = (event) => {
    const selected = carrOptions?.find((item) => item?.carr_code === event.target.value);
    setSelectedCarr(selected.carr_code);
    setNumCarrCode(selected.num_carr_code);
    setCarrName(selected.carr_name);
  };

  const handleCarrChange1 = (event) => {
    const selected = carrOptions?.find((item) => item?.carr_code === event.target.value);
    setSelectedCarr1(selected.carr_code);
    setNumCarrCode1(selected.num_carr_code);
    setCarrName1(selected.carr_name);
  };

  const addProduct = () => {
    let tempErrors = {};
    if (!productType) tempErrors.productType = "Product Type is required";
    if (!remarks) tempErrors.remarks = "Remarks cannot be empty";
  
    if (Object.keys(tempErrors).length > 0) {
      setErrors((prevErrors) => ({ ...prevErrors, ...tempErrors }));
      return;
    }
  
    setProductList([...productList, { producttype: productType, remarks }]);
    setProductType("");
    setRemarks("");
    
    // Clear only relevant errors
    setErrors((prevErrors) => ({ ...prevErrors, productType: undefined, remarks: undefined }));
    // if (productType && remarks) {
    //   setProductList([...productList, { producttype: productType, remarks }]);
    //   setProductType("");
    //   setRemarks("");
    // }
    // setErrors({});
  };

  const removeProduct = (index) => {
    const updatedList = productList.filter((_, i) => i !== index);
    setProductList(updatedList);
  };

  const handleSave = () => {
    if (!validate()) return;
    const payload = {
      carr_code: selectedCarr,
      num_carr_code: numCarrCode,
      carr_name: carrName,
      product_type: productList?.map(item => ({
        product_type: item?.producttype,
        remarks: item?.remarks
      }))
    };
    dispatch(newairlineproduct(payload)).then((res) => {
      if (res?.payload?.statusCode === 200) {
        dispatch(updatenotificationdata(res?.payload));
        setTab(0);
      } else if (res?.payload?.status === 406) {
        toast.error(res?.payload?.data?.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }).catch((err) => console.log(err));
  };

  const handleEdit = () => {
    setEditMode(true);
  };

  const handleUpdate = () => {
    if (productList?.length === 0 && selectedCarr1) {
      if (!validate()) return;
    }
    const payload = {
      carr_code: selectedCarr1,
      num_carr_code: numCarrCode1,
      carr_name: carrName1,
      airline_product_id: props?.airline_product_id?._id,
      product_type: productList?.map(item => ({
        product_type: item?.producttype,
        remarks: item?.remarks
      }))
    };
    dispatch(updateairlineproduct(payload)).then((res) => {
      if (res?.payload?.statusCode === 201) {
        dispatch(updatenotificationdata(res?.payload));
        setTab(0);
      } else if (res?.payload?.status === 406) {
        toast.error(res?.payload?.data?.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    }).catch((err) => console.log(err));
  };
  const allProductsAdded = productOptions.every((option) =>
    productList.some((p) => p.producttype === option)
  );
  return (
    <>
     <Box mt={3} sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
          {props ? (
            <>
              {!editMode ? (
                <Button variant="contained" sx={{ color: "#fff", backgroundColor: "#FFAF00", ":hover": { backgroundColor: "black" } }} onClick={handleEdit}>
                  Edit
                </Button>
              ) : (
                <Button variant="contained" sx={{ color: "#fff", backgroundColor: "#FFAF00", ":hover": { backgroundColor: "black" } }} onClick={handleUpdate}>
                  Update
                </Button>
              )}
            </>
          ) : (
            <Button variant="contained" sx={{ color: "#fff", backgroundColor: "#FFAF00", ":hover": { backgroundColor: "black" } }} onClick={handleSave}>
              Save
            </Button>
          )}
        </Box>
      <Box p={3}>
        {tab === 1 && (
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <FormControl fullWidth error={!!errors.selectedCarr}>
                <InputLabel>Carrier Code</InputLabel>
                <Select value={selectedCarr} onChange={handleCarrChange} disabled={editMode}>
                  {carrOptions.map((carr) => (
                    <MenuItem key={carr.carr_code} value={carr.carr_code}>
                      {carr.carr_code}
                    </MenuItem>
                  ))}
                </Select>
                {errors.selectedCarr && <FormHelperText>{errors.selectedCarr}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth label="Num Code" value={numCarrCode} disabled />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Airline" value={carrName} disabled />
            </Grid>
          </Grid>
        )}
        {tab === 2 && (
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <FormControl fullWidth error={!!errors.selectedCarr1}>
                <InputLabel>Carrier Code</InputLabel>
                <Select value={selectedCarr1} onChange={handleCarrChange1} disabled={!editMode}>
                  {carrOptions.map((carr) => (
                    <MenuItem key={carr.carr_code} value={carr.carr_code}>
                      {carr.carr_code}
                    </MenuItem>
                  ))}
                </Select>
                {errors.selectedCarr1 && <FormHelperText>{errors.selectedCarr1}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField fullWidth label="Num Code" value={numCarrCode1} disabled />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField fullWidth label="Airline" value={carrName1} disabled />
            </Grid>
          </Grid>
        )}

        <Box mt={3} p={2} border={1} borderRadius={2} borderColor="grey.400">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <FormControl fullWidth error={!!errors.productType}>
                <InputLabel>Product Type</InputLabel>
                {/* <Select value={productType} onChange={(e) => setProductType(e.target.value)} disabled={allProductsAdded ||tab===1?false:!editMode}> */}
                
                <Select
  value={productType}
  onChange={(e) => setProductType(e.target.value)}
  // disabled={tab !== 1 && (allProductsAdded || !editMode)}
  disabled={(tab !== 1 && (allProductsAdded || !editMode)) || (tab === 1 && allProductsAdded)}
>

  {productOptions.map((option) => (
                    <MenuItem key={option} value={option} disabled={productList.some((p) => p.producttype === option)}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
                {errors.productType && <FormHelperText>{errors.productType}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                placeholder="Remarks"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                error={!!errors.remarks}
                helperText={errors.remarks}
                // disabled={allProductsAdded ||tab===1?false:!editMode}
                // disabled={tab !== 1 && (allProductsAdded || !editMode)}
                disabled={(tab !== 1 && (allProductsAdded || !editMode)) || (tab === 1 && allProductsAdded)}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Button sx={{ fontSize: "25px", color: "#fff", backgroundColor: "#FFAF00",
                ":hover": { backgroundColor: "black" } }} variant="contained" onClick={addProduct} 
                // disabled={allProductsAdded ||tab===1?false:!editMode}
                // disabled={tab !== 1 && (allProductsAdded || !editMode)}//
                disabled={(tab !== 1 && (allProductsAdded || !editMode)) || (tab === 1 && allProductsAdded)}
                >
                +
              </Button>
            </Grid>
          </Grid>

          <Box mt={2}>
            {productList.map((item, index) => (
              <Box key={index} p={1} display="flex" justifyContent="space-around" alignItems="center" borderBottom="1px solid #ccc">
                <span>{item.producttype ? item.producttype : item.product_type}</span>
                <span>{item.remarks}</span>
                <IconButton color="error" onClick={() => removeProduct(index)} disabled={tab===1?false:!editMode}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
          </Box>
        </Box>

       
      </Box>
      <ToastContainer />
    </>
  );
};

export default AirlineproductForm;